var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelefone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.808,5C7.6,2.608,5.1,1.432,4.995,1.384a.531.531,0,0,0-.317-.043C1.793,1.82,1.359,3.5,1.341,3.57a.54.54,0,0,0,.011.295C4.793,14.548,11.945,16.528,14.3,17.179c.181.05.33.091.444.128a.539.539,0,0,0,.394-.023,4.42,4.42,0,0,0,2.186-3.445.544.544,0,0,0-.052-.334,5.172,5.172,0,0,0-3.39-2.362.532.532,0,0,0-.482.115A7.284,7.284,0,0,1,11.08,12.7,10.284,10.284,0,0,1,6.173,7.714,5.85,5.85,0,0,1,7.666,5.423.545.545,0,0,0,7.808,5Z",
    transform: "translate(2.674 2.667)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.43b2b9f03d59ca74944505ba3fdcc2e0.svg";
export { ForwardRef as ReactComponent };